// extracted by mini-css-extract-plugin
export var postPreviews = "postpreviews-module--postPreviews--H00Zm";
export var postPreviewContainer = "postpreviews-module--postPreviewContainer---FL9m";
export var footerContainer = "postpreviews-module--footerContainer--dazYn";
export var separatorIcon = "postpreviews-module--separatorIcon--bU+TR";